import { ref, computed, onMounted, onUnmounted, ComputedRef } from 'vue';

export interface IUseMobile {
  isMobile: ComputedRef<boolean>;
}

export const useMobile = (): IUseMobile => {
  const screenWidth = ref(window.innerWidth);
  const mobileMaxWidth = 768;

  const isMobile = computed(() => {
    return screenWidth.value <= mobileMaxWidth;
  });

  const updateScreenWidth = () => {
    screenWidth.value = window.innerWidth;
  };

  onMounted(() => {
    window.addEventListener('resize', updateScreenWidth);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateScreenWidth);
  });

  return {
    isMobile,
  };
};
